(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c83"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c83"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bB0zn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8713978b2328d32b$export$71511d61b312f219; });
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("6QEWP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4fc75ccb937ab1df$export$71511d61b312f219; });
function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});


var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");
var $59bdea93f29f00f1$var$nav = {
    init: function() {
        var _this = this;
        var nav = document.querySelector('nav');
        if (!nav) return;
        var subnavContainer = document.querySelector('.header__nav-background');
        this.hamburger();
        this.desktopHover(nav, subnavContainer);
        window.addEventListener('resize', function() {
            return _this.handleResize(nav, subnavContainer);
        });
        // Shops 
        this.setShopCategories();
    },
    hamburger: function() {
        var hamburger = document.querySelector('.hamburger');
        var nav = document.querySelector('nav');
        if (!hamburger) return;
        hamburger.addEventListener('click', function() {
            hamburger.classList.toggle('active');
            nav.classList.toggle('show');
        });
    },
    desktopHover: function(nav, subnavContainer) {
        this.setSubmenuBackground(nav, subnavContainer);
        var mainChildrens = document.querySelectorAll('.nav-main li.menu-container');
        mainChildrens.forEach(function(mainChildren) {
            mainChildren.addEventListener('mouseenter', function() {
                subnavContainer.classList.add('active');
                nav.classList.add('active');
            });
        });
        nav.addEventListener('mouseleave', function() {
            subnavContainer.classList.remove('active');
            nav.classList.remove('active');
        });
    },
    setSubmenuBackground: function(nav, subnavContainer) {
        var navHeight = nav.scrollHeight - nav.offsetHeight;
        var hoverElements = document.querySelectorAll('.hover-background');
        subnavContainer.style.height = navHeight + 'px';
        hoverElements.forEach(function(hoverElement) {
            return hoverElement.style.height = navHeight + 'px';
        });
    },
    handleResize: function(nav, subnavContainer) {
        subnavContainer.removeAttribute('style');
        this.setSubmenuBackground(nav, subnavContainer);
    },
    setShopCategories: function() {
        var shopCategoriesButton = document.querySelector('.shop-categories-button');
        if (!shopCategoriesButton) return;
        var shopCategoriesList = document.querySelector('.shop-categories-list');
        shopCategoriesButton.addEventListener('click', function() {
            shopCategoriesList.classList.toggle('active');
            if (shopCategoriesList.classList.contains('active')) shopCategoriesButton.setAttribute('aria-expanded', 'true');
            else shopCategoriesButton.setAttribute('aria-expanded', 'false');
        });
        window.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                shopCategoriesList.classList.remove('active');
                shopCategoriesButton.setAttribute('aria-expanded', 'false');
            }
        });
        this.setShopAccordion();
    },
    setShopAccordion: function() {
        var categoryTitle = document.querySelectorAll(".category-title");
        if (categoryTitle.length === 0) return;
        categoryTitle.forEach(function(category) {
            category.addEventListener("click", function(event) {
                event.preventDefault();
                var submenu = this.nextElementSibling;
                if (submenu && submenu.classList.contains("submenu")) {
                    if (window.matchMedia('(min-width: 1024px)').matches) {
                        var currentActive = document.querySelector('.submenu.active');
                        if (currentActive && currentActive !== submenu) currentActive.classList.remove('active');
                        var currentActiveCategory = document.querySelector('.category-title.active');
                        if (currentActiveCategory && currentActiveCategory !== category) currentActiveCategory.classList.remove('active');
                        submenu.classList.toggle('active');
                        category.classList.toggle('active');
                    } else if (submenu.style.maxHeight) submenu.style.maxHeight = null;
                    else submenu.style.maxHeight = submenu.scrollHeight + "px";
                }
            });
        });
    }
};
var $59bdea93f29f00f1$export$2e2bcd8739ae039 = $59bdea93f29f00f1$var$nav;


var $d4ea292d5fea940b$var$modal = {
    settings: {
        modalName: 'information-modal',
        isCookie: null
    },
    init: function() {
        this.setModal();
    },
    setModal: function() {
        var _this = this;
        var modalCustom = document.querySelector('.modal-custom');
        if (!modalCustom) return;
        this.settings.isCookie = this.getCookie(this.settings.modalName);
        if (this.settings.isCookie) return;
        var modalCustomContainer = modalCustom.querySelector('.modal-custom__container');
        modalCustom.classList.add('active');
        var button = modalCustom.querySelector('a.button-custom');
        button === null || button === void 0 ? void 0 : button.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.setCookie(_this.settings.modalName, true, balsamData.modal_cookie_expiration);
            var target = button.target ? button.target : '_self';
            var url = button.href;
            window.open(url, target);
            modalCustom.classList.remove('active');
        });
        var close = document.querySelector('.modal-custom__close');
        close.addEventListener('click', function() {
            return _this.closeModal(_this.settings.isCookie, modalCustom);
        });
        window.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') _this.closeModal(_this.settings.isCookie, modalCustom);
        });
        // Prevent closing the modal on click
        modalCustomContainer.addEventListener('click', function(e) {
            return e.stopPropagation();
        });
        document.addEventListener('click', function() {
            _this.closeModal(_this.settings.isCookie, modalCustom);
        });
    },
    closeModal: function(isCookie, modalCustom) {
        if (!isCookie) {
            this.setCookie(this.settings.modalName, true, balsamData.modal_cookie_expiration);
            this.settings.isCookie = this.getCookie(this.settings.modalName);
            modalCustom.classList.remove('active');
        }
    },
    setCookie: function(name, value, days) {
        var expires = '';
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 86400000);
            expires = "; expires=".concat(date.toUTCString());
        }
        document.cookie = "".concat(name, "=").concat(value || '').concat(expires, "; path=/");
    },
    getCookie: function(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
};
var $d4ea292d5fea940b$export$2e2bcd8739ae039 = $d4ea292d5fea940b$var$modal;


var $a99de7c4e1fbb09a$var$global = {
    init: function() {
        jQuery('body').on('added_to_cart', function() {
            $a99de7c4e1fbb09a$var$global.getProductsCount();
        });
        jQuery('body').on('removed_from_cart', function() {
            $a99de7c4e1fbb09a$var$global.getProductsCount();
        });
        jQuery('body').on('wc_cart_emptied', function() {
            $a99de7c4e1fbb09a$var$global.getProductsCount();
        });
        jQuery('body').on('updated_cart_totals', function() {
            $a99de7c4e1fbb09a$var$global.getProductsCount();
        });
    },
    getProductsCount: function() {
        var cartCounts = document.querySelectorAll('#cart-items-count');
        if (!cartCounts) return;
        var params = new URLSearchParams({
            action: 'get_products_count'
        });
        fetch("".concat(balsamData.ajaxurl, "?").concat(params.toString()), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': balsamData.nonce
            }
        }).then(function(response) {
            return response.json();
        }).then(function(data) {
            if (!data.success) return;
            cartCounts.forEach(function(cartCount) {
                cartCount.textContent = data.data.count;
            });
        }).catch(function(error) {
            return console.error('Fetch error:', error);
        });
    }
};
var $a99de7c4e1fbb09a$export$2e2bcd8739ae039 = $a99de7c4e1fbb09a$var$global;


var $847553d13b80c4b3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function App() {
        (0, $bB0zn._)(this, App);
        this.initDev();
        this.initBody();
    }
    (0, $6QEWP._)(App, [
        {
            key: "initBody",
            value: function initBody() {}
        },
        {
            key: "initCore",
            value: function initCore() {
                (0, $59bdea93f29f00f1$export$2e2bcd8739ae039).init();
                (0, $d4ea292d5fea940b$export$2e2bcd8739ae039).init();
                (0, $a99de7c4e1fbb09a$export$2e2bcd8739ae039).init();
            }
        },
        {
            key: "initDev",
            value: function initDev() {}
        }
    ]);
    return App;
}();
function $847553d13b80c4b3$var$LoadApp() {
    var app = new $847553d13b80c4b3$export$2e2bcd8739ae039();
    app.initCore();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $847553d13b80c4b3$var$LoadApp);
else $847553d13b80c4b3$var$LoadApp();

})();
//# sourceMappingURL=_app.js.map
